import React, { Component } from 'react';
import { WebsiteLayout } from '~/components/common/layout';
import { Careers } from '~/components/screens';

export default function PageWithLayout({ logout, user }) {
  return (
    <WebsiteLayout navbarBackgroundColor="white" user={user} handleLogout={logout}>
      <Careers />
    </WebsiteLayout>
  );
}
